module.exports = __webpack_public_path__ + "static/img/value-bg.1cf5be22.png";